/**
 * Add or update newsletter subscriber.
 * 
 * @param {string} email 
 * @param {string} firstName 
 * @param {string} lastName 
 * @param {string} phone 
 * @param {boolean} isWARes 
 * @param {string} zipCode 
 * @param {string} address 
 * @param {string} memberId
 * 
 * @returns {(string|false)} Subscriber hash on success, false on failure.
 */
export async function registerSubscriber(email, firstName, lastName, phone, isWARes, zipCode, address, memberId) {
    const body = {
        email,
        firstName,
        lastName,
        phone,
        isWARes,
        zipCode,
        address,
        nonce: window.myAjax.nonce
    };

    if(memberId) {
        body['memberId'] = memberId;
    }
    
    const response = await fetch('/wp-json/custom/v1/handle-ajax-mailchimp-subscriber', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(body)
    });
    
    return response.ok ? email : false;
};
